
import { Loader } from "@googlemaps/js-api-loader";

export default {
	GOOGLE_API_KEY: `AIzaSyCMuqe8_JOvYVMs2ozP9XfO3DHLFVNTa2A`,
	GOOGLE_MAPS_LOADER: null,
	async getGoogleMapsClient() {
		if (this.GOOGLE_MAPS_LOADER) return this.GOOGLE_MAPS_LOADER;

		const loader = new Loader({
			apiKey: this.GOOGLE_API_KEY,
			version: "weekly",
			libraries: ["geocoding", "maps", "places"]
		});

		this.GOOGLE_MAPS_LOADER = await loader.load();

		return this.GOOGLE_MAPS_LOADER;
	}
}
